import { DefaultTheme } from "styled-components";

interface IMyThemeColors {}

interface IMyTheme extends DefaultTheme {}

const myTheme: IMyTheme = {};

export { myTheme, IMyTheme, IMyThemeColors };
